<template>
  <div>
    <SectionOne v-if="current===0" :projectId="projectId" />
    <SectionTwo v-if="current===1" :projectId="projectId" />
    <SectionThree v-if="current===2" :projectId="projectId" />
    <div class="action-container action-container__bottom">
      <a-button :disabled="current<=0" @click="previousSection" class="action-btn first-action-btn">
        上一部分
      </a-button>
      <a-button :disabled="current>=2" @click="nextSection" class="action-btn" >
        下一部分
      </a-button>
      <div v-if="canReview" class="audit-btn-container">
        <a-button  type="primary" class="action-btn" @click="onPass">
          评估通过
        </a-button>
        <a-button  type="danger" class="action-btn" @click="onReject">
          评估不通过
        </a-button>
        <a-input  placeholder="请输入复核意见" v-model="auditOpinion" style="width:300px"/>
      </div>
      <span v-else>状态：{{ sectionState }}</span>
    </div>
  </div>
</template>
<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import BreadcrumbItem from "@/components/BreadcrumbItem.vue";
import {baseURL} from "@/services/HttpService";
import {saveRiskAssess} from "@/services/RiskService";
import SectionOne from "@/views/SectionOne.vue";
import SectionTwo from "@/views/SectionTwo.vue";
import SectionThree from "@/views/SectionThree.vue";
import {loadProjectStates} from "@/services/DocService";

export default {
  components: {SectionThree, SectionTwo, BreadcrumbItem, Breadcrumb, SectionOne },
  data() {
    return {
      projectId: "",
      current: 0,
      headers: {
        authorization: 'authorization-text',
      },
      viewUrl: baseURL + "/attachment?fileName=",
      projectStates: {
        state: "未提交",
        rationaleState: "未提交",
        internalState: "未提交",
        riskReviewState: "未提交",
        rationaleRiskState: "未提交",
        internalRiskState: "未提交"
      },
      auditOpinion: ""
    };
  },
  computed: {
    canReview() {
      if (this.current===0) {
        return this.projectStates.riskReviewState !== "通过" && this.projectStates.riskReviewState !== "已驳回";
      } else if (this.current===1) {
        console.log('current = 1 and rationaleRiskState', this.projectStates.rationaleRiskState);
        return this.projectStates.rationaleRiskState !== "通过" && this.projectStates.rationaleRiskState !== "已驳回";
      } else if (this.current===2) {
        console.log('current = 2 and internalRiskState', this.projectStates.internalRiskState);
        return this.projectStates.internalRiskState !== "通过" && this.projectStates.internalRiskState !== "已驳回";
      }
    },
    sectionState() {
      if(this.current===0) {
        return this.projectStates.riskReviewState;
      } else if (this.current===1){
        return this.projectStates.rationaleRiskState;
      } else if (this.current===2) {
        return this.projectStates.internalRiskState;
      }
      return "";
    }
  },
  created() {
    this.projectId = this.$route.params.id;
    if(this.projectId && this.projectId !== "0") {
      this.startLoadProjectStatus();
    }
    console.log('projectId', this.projectId);
  },
  methods: {
    startLoadProjectStatus() {
      loadProjectStates(this.projectId).then(resp => {
        if (resp.data.code === "SUCCESS") {
          this.projectStates = resp.data.data;
        }
      });
    },
    onPass() {
      let params = {
        projectId: this.projectId,
        pass: true,
        remark: this.auditOpinion
      }
      this.audit(params);
    },
    onReject() {
      let params = {
        projectId: this.projectId,
        pass: false,
        remark: this.auditOpinion
      }
      this.audit(params);
    },
    audit(params) {
      if(this.current===0){
        params.section = "sectionOne";
      }
      if(this.current===1){
        params.section = "sectionTwo";
      }
      if(this.current===2){
        params.section = "sectionThree";
      }
      saveRiskAssess(params).then(resp => {
        if (resp.data.code === "SUCCESS") {
          this.$message.success("操作成功");
          this.auditOpinion = "";
          this.startLoadProjectStatus();
        } else {
          this.$message.error("操作失败:" + resp.data.errorMsg);
        }
      });
    },
    previousSection() {
      if(this.current > 0){
        this.current--;
      }
    },
    nextSection() {
      if(this.current < 3) {
        this.current = this.current + 1;
      }
    },

  }
}
</script>
<style scoped>

</style>
